import React from 'react';

const ColumnVisibilityModal = ({ columns, visibleColumns, onChange, onClose, isOpen, show }) => {
  const modalOpen = isOpen || show;
  if (!modalOpen) return null;

  // Fechar ao clicar no backdrop
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" 
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
        {/* Header com botão X */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">Exibir/Ocultar Colunas</h2>
          <button 
            type="button" 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
            aria-label="Fechar"
          >
            &times;
          </button>
        </div>
        
        <form>
          <div className="flex flex-col gap-2 mb-4">
            {columns.map(col => (
              <label key={col.accessor} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={visibleColumns.includes(col.accessor)}
                  onChange={() => onChange(col.accessor)}
                  className="form-checkbox h-4 w-4 text-green-600"
                />
                <span className="text-sm">{col.Header}</span>
              </label>
            ))}
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-gray-700" onClick={onClose}>Fechar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ColumnVisibilityModal;
